import React from "react";
import styles from "../../styles/common/dashboardCard.module.css";
import increase from "../../../src/assets/images/Increase.svg";
import decrease from "../../../src/assets/images/Decrease.svg";
import { formatNumberCommaSeparated } from "../../utils/common";

const DashboardCard = ({
  title,
  subHeading,
  value,
  changeValue,
  change,
  subHeading1,
  subchange,
  subvalue,
  subchangeValue,
  unit,
  subUnit,
}) => {
  return (
    <>
      <div className={styles.cards_container}>
        <div style={{ marginBottom: "1rem" }}>
          <p className={styles.card_title}>{title}</p>
          <p className={styles.card_subheading}>{subHeading}</p>
        </div>
        <div className={styles.cards_value}>
          <p className={styles.value}>
            {formatNumberCommaSeparated(value)}
            {unit}
          </p>
          <div className={styles.card_value_container}>
            <p
              className={
                change === "increase"
                  ? styles.card_value_inc
                  : change === "decrease"
                  ? styles.card_value_dec
                  : ""
              }
            >
              {changeValue}
            </p>
            {change && (
              <img
                src={change === "increase" ? increase : decrease}
                alt={change}
                style={{ width: "18px" }}
              />
            )}
          </div>
        </div>
        {subHeading1 && <p className={styles.card_subheading}>{subHeading1}</p>}
        <div className={styles.cards_value}>
          <p className={styles.value}>
            {formatNumberCommaSeparated(subvalue)} {subUnit}
          </p>
          <div className={styles.card_value_container}>
            <p
              className={
                subchange === "increase"
                  ? styles.card_value_inc
                  : subchange === "decrease"
                  ? styles.card_value_dec
                  : ""
              }
            >
              {subchangeValue && subchangeValue + " YOY"}
            </p>
            {subchange && (
              <img
                src={subchange === "increase" ? increase : decrease}
                alt={change}
                style={{ width: "18px" }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardCard;
